
import { Component, Prop, Vue } from "vue-property-decorator";
import { getImgConfig } from "@/api/login";
import { encryptData } from "@/utils/encryptData";

@Component
export class ImgCaptchaPopup extends Vue {
  @Prop({ default: "" }) mobile!: string; // 手机号

  show = false
  smsCode = ''
  imgConfig: { verifyCode: string; verifyCodeImgIsBaseVal: string } = null
  errShakeClass = 'animate__animated animate__headShake'
  isSmsCodeErr = false
  isRefresh = false
  showPopup () {
    this.smsCode = ''
    this.show = true
    this.getImgConfigFunc()
  }

  onRefreshClick () {
    this.isRefresh = true
    this.getImgConfigFunc()
    setTimeout(() => {
      this.isRefresh = false
    }, 600)
  }

  // 获取图片验证码
  getImgConfigFunc () {
    getImgConfig({ mobile: encryptData(this.mobile) }).then(res => {
      this.imgConfig = res.data
    })
  }

  onSmsCodeInput () {
    this.isSmsCodeErr && (this.isSmsCodeErr = false)
  }

  onConfirm () {
    if ((this.smsCode).toLowerCase() != (this.imgConfig.verifyCode).toLowerCase()) {
      this.isSmsCodeErr = true
      return
    }
    this.$emit('confirm', this.smsCode)
    this.show = false
  }
}
export default ImgCaptchaPopup
